export default "__VITE_ASSET__BmJyLA9K__"